const matching = {
  title: "מנוע התאמות",
  description: "התאמות AI בין ישויות — עובדים, פרויקטים, קבלנים ולידים",
  sourceEntity: "ישות מקור",
  targetType: "סוג יעד",
  findMatches: "מצא התאמות",
  noMatches: "לא נמצאו התאמות",
  score: "ציון",
  semanticScore: "ציון סמנטי",
  fieldScore: "ציון שדות",
  recencyScore: "ציון עדכניות",
  breakdown: "פירוט",
  cached: "מהמטמון",
  refresh: "רענון",
  refreshAll: "רענן הכל",
  topMatches: "התאמות מובילות",
  loadingMatches: "מחפש התאמות...",
  selectSource: "בחר ישות מקור",
  selectType: "בחר סוג ישות",
  matchProfile: "פרופיל התאמה",
  editProfile: "ערוך פרופיל",
  saveProfile: "שמור",
  highMatch: "התאמה גבוהה",
  mediumMatch: "התאמה בינונית",
  lowMatch: "התאמה נמוכה",
  matchedOn: "הותאם לפי",
  lastComputed: "חושב לאחרונה",
  viewEntity: "צפה בישות",
  batchScore: "ניקוד קבוצתי",
  allTypes: "כל הסוגים",
  matchError: "שגיאה במציאת התאמות",
} as const;
export default matching;
